"use strict";

exports.__esModule = true;
exports.omni = exports.nobia = exports.next = exports.getOmniState = exports.getNobiaState = exports.getNextDataState = void 0;
/* eslint-disable no-underscore-dangle */
var getNobiaState = exports.getNobiaState = function getNobiaState() {
  if (typeof window === 'undefined') return undefined;
  window.nobia = window.nobia || {};
  return window.nobia;
};
var getOmniState = exports.getOmniState = function getOmniState() {
  if (typeof window === 'undefined' || window.__OMNI__ == null) {
    return undefined;
  }
  return window.__OMNI__;
};
var getNextDataState = exports.getNextDataState = function getNextDataState() {
  if (typeof window === 'undefined' || window.__NEXT_DATA__ == null) {
    return undefined;
  }
  return window.__NEXT_DATA__;
};
var nobia = exports.nobia = getNobiaState();
var omni = exports.omni = getOmniState();
var next = exports.next = getNextDataState();